import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMantenedorCategoriaService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    refreshTable() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventMantenedorCategoriaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMantenedorCategoriaService_Factory() { return new EventMantenedorCategoriaService(); }, token: EventMantenedorCategoriaService, providedIn: "root" });
